<template>
  <div class="cardRayonXcontainer">
    <div id="cardRayonX">
      <div class="front" :style="'transform-origin:' + direction">
        <img :src="imgSrc" alt="" />
        <div class="title">{{ title }}</div>
      </div>
      <div class="back">
        <div class="content" style="height: 100%;">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default { props: ["direction", "title", "imgSrc", "content"] };
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

.cardRayonXcontainer {
  display: flex;
  align-items: center;
  justify-content: center;

  #cardContentRayonX {
    text-align: center;
    font: normal normal normal 15px/30px Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;

    .cardContentRayonX_title {
      text-align: center;
      font: normal normal bold 25px/40px Segoe UI;
      letter-spacing: 0px;
      color: $purple_color;
      opacity: 1;
    }

    .btnCardContent {
      background: $purple_color 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 41px;
      opacity: 1;
      border: none;
    }
  }
}

#cardRayonX {
  height: 100vh;
  width: 100vh;
  max-width: 450px;
  max-height: 450px;
  min-width: 400px;
  min-height: 400px;
  position: relative;
  background: #242527 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 20px;
  opacity: 1;
  transition: 1s all;
  margin: 20px;
  overflow: hidden;

  .front {
    $animStyle: ease-out;
    $animTime: 0.5s;
    transform: rotateY(0deg);
    position: absolute;
    border-radius: 20px;
    background: #242527;
    transition: 1s all;
    text-align: center;
    height: 100%;
    width: 100%;
    padding: 20px;
    z-index: 2;
    top: 0;
    opacity: 1;
    left: 0;
    img {
      width: 80%;
      transition: $animTime $animStyle;
      height: 80%;
      padding: 20px;
      opacity: 1;
    }
    .title {
      opacity: 1;
      transition: $animTime $animStyle;
      color: $mf_ft_color_vlt;
      font-weight: bold;
      text-align: center;
      font: normal normal bold 35px/40px Segoe UI;
      letter-spacing: 0px;
    }
  }
  &:hover {
    .front {
      opacity: 0;
      visibility: hidden;
      img {
        opacity: 0.2;
        //visibility: hidden;
      }
      .title {
        opacity: 0;
        //visibility: hidden;
      }
    }
  }
  .back {
    color: $mf_ft_color_white;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 1;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .content {
      padding: 20px;
      .title {
        text-align: center;
        font: normal normal bold 45px/60px Segoe UI;
        letter-spacing: 0px;
        opacity: 1;
        color: $purple_color;
      }
    }
  }
}
</style>
